var audio_rtlignore_default = {
  "fontElementMap": "_4G-jP",
  "container": "sU4XM",
  "customPlayer": "yRqpr",
  "slim": "MnEd2",
  "playPauseButton": "hIOXF",
  "coverImage": "B28Wn",
  "trackDetailsContainer": "_8dXdP",
  "controlsContainer": "xn41O",
  "controlsGroup": "w62-I",
  "sliderContainer": "CKNjC",
  "audioDuration": "zW9p7",
  "isLoading": "oXHjp",
  "audioIconButton": "xOhTA",
  "audioVolumeWrapper": "YX8HQ",
  "volumeSliderWrapper": "_--Ul1",
  "audioDetails": "jvpmR",
  "authorName": "yLztX",
  "title": "kGYvd",
  "audioContextMenuWrapper": "I-dwk",
  "dropdownMenuWrapper": "AJ4mm",
  "dropdownSelectedButton": "O9P1z",
  "dropdownContent": "Uu0JH",
  "dropdownContentWithIcon": "OBxkn",
  "audioLoader": "T961y"
};
export {
  audio_rtlignore_default as default
};
//# sourceMappingURL=audio.rtlignore-scss.js.map
